import { Injectable } from '@angular/core';
import moment from 'moment';
import { FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CoreConfigService } from '../core/core.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(
    private _HttpClient: HttpClient,
    private _CoreConfigService: CoreConfigService
  ) {}

  CreateShortLink(full_url: string): Observable<any> {

    return this._HttpClient.post<any>(
      (this._CoreConfigService.base_config.api_path) +
        '/api/sys/getshorturl',
      {
        full_url: full_url,
      }
    );
    
  }

  MomentConvertStringtoDateformat(
    inputdate: string,
    originalFormat: string,
    tragetFormat: string = 'DD/MM/YYYY HH:mm:ss'
  ) {
    return moment(inputdate, originalFormat).format(tragetFormat);
  }

  MomentConvertStringToDate(inputdate: string, originalFormat: string) {
    return moment(inputdate, originalFormat).toDate();
  }

  compareSortNumer(a: number, b: number, isAsc) {
    return isAsc ? a - b : b - a;
  }
  MomentConvertDateToServerFormByDate(date: any) {
    if (date) {
      // return moment(date).format('DD/MM/YYYYTHH:mm:ss');
      return moment(date).format('YYYY-MM-DDTHH:mm:ss');
    }
    return '';
  }

  MomentIssameDate(date: any, date2: any) {
    if (date && date2)
      return moment(moment(date).format('DD/MM/YYYY')).isSame(
        moment(date2).format('DD/MM/YYYY'),
        'day'
      );
    return false;
  }

  RandomVendorInvoiceNo(key) {
    return key + '-' + Math.round(Math.random() * (100 - 1) + 1);
  }

  compareSort(a, b, isAsc) {
    return (a > b ? 1 : a < b ? -1 : 0) * (isAsc ? 1 : -1);
  }
  downloadcsv(data: any, exportFileName: string) {
    var csvData = this.convertToCSV(data);

    var blob = 'data:text/csv;charset=utf-8,\uFEFF' + encodeURI(csvData);
    var link = document.createElement('a');

    link.setAttribute('href', blob);
    link.setAttribute('download', this.createFileName(exportFileName));
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  convertToCSV(args: any) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;
    data = args || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;
    var countingitem = 0;
    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;
        if (item[key] === null || item[key] === undefined || item[key] === '')
          result += '';
        else if (
          typeof item[key] === 'number' ||
          typeof item[key] === 'boolean'
        ) {
          result += '' + item[key] + '';
        }
        else {
          result += '"' + item[key].split(/"/g).join('""') + '"';
        }
        ctr++;
      });
      countingitem++;
      result += lineDelimiter;
    });
    return result;
  }

  createFileName(exportFileName: string): string {
    var date = new Date();
    return (
      exportFileName +
      '.csv'
    );
  }
}
// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
